import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import * as URL from './url';

const RootPage = lazy(() => import('../components/screens/home'));
const AboutPage = lazy(() => import('../components/screens/about'));
const ProjectsPage = lazy(() => import('../components/screens/projects'));
// const ProjectDetailsPage = lazy(() => import('../components/screens/projects/project_details'));
const VacanciesPage = lazy(() => import('../components/screens/vacancies'));
const VacancyDetailsPage = lazy(() => import('../components/screens/vacancies/vacancy_details'));
const ContactsPage = lazy(() => import('../components/screens/contacts'));
const AutomationPage = lazy(() => import('../components/screens/automation'));
const CommissioningWorksPage = lazy(() => import('../components/screens/commissioning_works'));
const NotFoundPage = lazy(() => import('../components/screens/not_found'));


export default (
    <Routes>
        {
            /*
            exact - булевый пропс, означает, что маршрут должен отработать именно на указанном пути,
            т.е. "/" как бы включен внутрь любого более широкого урла, наприиер "/details", соответственно
            мы хотим сказать чтобы отработал именно "/"

            path - путь URL в строке запроса в браузере

            component - компонент React  который надо загрузить для данного урла
             */
        }
        <Route exact path={URL.ROOT} element={<RootPage />} />
        <Route exact path={URL.ABOUT} element={<AboutPage />} />
        <Route exact path={URL.PROJECTS} element={<ProjectsPage />} />
        {/* <Route exact path={ URL.PROJECT_DETAILS } component={ ProjectDetailsPage } /> */}
        <Route exact path={URL.VACANCIES} element={<VacanciesPage />} />
        <Route exact path={URL.VACANCY_DETAILS} element={<VacancyDetailsPage />} />
        <Route exact path={URL.CONTACTS} element={<ContactsPage />} />
        <Route exact path={URL.AUTOMATION} element={<AutomationPage />} />
        <Route exact path={URL.COMMISSIONING_WORKS} element={<CommissioningWorksPage />} />
        <Route path="*" element={<NotFoundPage />} />
    </Routes>
);